import { useMemo } from 'react'
import { formatInTimeZone } from 'date-fns-tz'
import { UpcomingInvoiceDetail } from 'api/payment'
import { Box, Flex, Table, Text, useResponsiveValue } from 'ui'
import { formatCurrency } from 'lib/string'
import { InvoiceGroupCell } from 'components/InvoiceGroupCell'
import { columns } from './columns'

const DEFAULT_WEEK_TIMEZONE = 'America/Los_Angeles'
const DATE_FORMAT = 'MM/dd/yyyy zzz'

type Props = {
  data: UpcomingInvoiceDetail
}

export function UpcomingInvoiceDetails({ data }: Props) {
  const total = useMemo(() => {
    return data.items.reduce((acc, item) => {
      return acc + Number(item.amount)
    }, 0)
  }, [data])
  const columnsToUse = useResponsiveValue([1, 6])
  const tableVariant = useResponsiveValue<'borderless' | 'standard'>([
    'borderless',
    'standard',
  ])
  const invoiceDate = formatInTimeZone(
    new Date(data.cutoffAt),
    data.weekTimezone || DEFAULT_WEEK_TIMEZONE,
    DATE_FORMAT
  )

  return (
    <Box>
      <Flex alignItems="center" flexWrap="wrap" mb={3}>
        <Box width={[1, 1, 'auto']}>
          <Flex mt={1} alignItems="center" style={{ gap: 8 }}>
            <Text>Invoice group:</Text>
            <InvoiceGroupCell
              invoiceGroup={data.invoiceGroup}
              invoiceGroupKey={data.invoiceGroupKey}
            />
          </Flex>
          <Text mt={1}>
            Invoice cutoff:&nbsp;
            <Text inline fontWeight={2}>
              {invoiceDate}
            </Text>
          </Text>
        </Box>
      </Flex>
      <Table
        variant={tableVariant}
        columns={columns.slice(0, columnsToUse)}
        data={data.items}
      />
      <Flex mt={3} justifyContent="flex-end" alignItems="center">
        Total&nbsp;&nbsp;
        <Text fontSize={3} fontWeight={2}>
          {formatCurrency(total)}
        </Text>
      </Flex>
    </Box>
  )
}
